import { Pause, Play } from 'lucide-react';
import React, { useState, useEffect, useCallback } from 'react';

interface VoicesProps {
  title: string;
  names: {
    name: string | undefined;
    url: string | undefined;
    voice: string | undefined;
    gender: string | undefined;
  }[];
  selectedName: string;
  setSelectedName: (name: string) => void;
}

interface HandlePlayParams {
  name: string;
  audioUrl: string;
}

const Voices: React.FC<VoicesProps> = ({
  title,
  names,
  selectedName,
  setSelectedName,
}) => {
  const [isPlaying, setIsPlaying] = useState<string | null>(null);
  const [audio, setAudio] = useState<HTMLAudioElement | null>(null);

  useEffect(() => {
    return () => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, [audio]);

  const handlePlay = useCallback(
    ({ name, audioUrl }: HandlePlayParams): void => {
      if (isPlaying === name) {
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
        }
        setIsPlaying(null);
      } else {
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
        }
        const newAudio = new Audio(audioUrl);
        newAudio.play();
        setAudio(newAudio);
        setIsPlaying(name);

        // Auto-stop when audio ends
        newAudio.addEventListener('ended', () => {
          setIsPlaying(null);
        });
      }
    },
    [audio, isPlaying]
  );

  return (
    <div className="w-full  h-[250px]">
      <h2 className="text-[12px] font-semibold mb-2 text-text-secondary">
        {title}
      </h2>
      <div className="h-[200px] overflow-y-auto scollbar-hide">
        {names.map((item) => (
          <button
            key={item.name}
            onClick={() => {
              if (item.name) {
                setSelectedName(item.name);
                if (item.voice) {
                  handlePlay({ name: item.name, audioUrl: item.voice });
                }
              }
            }}
            className={`w-full flex items-center mb-2 pl-2 justify-between  rounded-lg  border ${
              selectedName === item.name
                ? 'border-text-selected border-4 '
                : 'border-text-secondary '
            }`}
          >
            <div className="flex items-center gap-3 py-1">
              <img
                src={item.url}
                alt={`${item.name} avatar`}
                className="w-8 h-8 rounded-md"
              />
              <span
                className={`text-[16px] ${selectedName == item.name ? 'text-primary' : 'text-text-primary'}`}
              >
                {item.name}
              </span>
            </div>
            <div
              className={`w-10 h-10  flex items-center justify-center ${selectedName == item.name ? '' : 'rounded-r-md'}  bg-[#846CEC] text-white`}
              onClick={(e) => {
                e.stopPropagation();
                if (item.name && item.voice) {
                  handlePlay({ name: item.name, audioUrl: item.voice });
                }
              }}
            >
              {isPlaying === item.name ? <Pause /> : <Play />}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Voices;
